module.exports = __webpack_public_path__ + "static/img/tianyu.be5c16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tianyu.png
// module id = ci4a
// module chunks = 26